import React, { useState, useEffect } from 'react'

import {
  CBStep,
  CBSteps,
  CBInput,
  CBButton,
  SubmitButton,
  CBHeader,
  CBCheckItem,
  CBRadioGroupBig,
  CBRadioGroup,
  CBListItem,
  CBColorPicker,
  CBModal,
  CBSelect,
  CBList,
  CBUrlField,
} from '../../core/components/cbd'

import momentTz from 'moment-timezone'

const CBCalendar = ({ range, excludedDays=[],passDate, singleSelect=true, loading=false, onSelect = (e => console.log(e))
    , onRangeSelect = (e => console.log(e)), onPanelChange=(e=> console.log(e)), sundayStart=true}) => {
    const [date, setDate] = useState(passDate )
    const [dayOfMonth, setDayOfMonth] = useState(date.date())
    const [firstSelect, setFirstSelect] = useState(null)
    const [secondSelect, setSecondSelect] = useState(null)
 
    function generateDays() {
      const firstOfMonth = date.clone().date(1)
      const prevMonth = firstOfMonth.clone().month(firstOfMonth.month() - 1)
      const lastDayInMonth = date.clone().date(firstOfMonth.daysInMonth() - 1)
      var firstDayOfWeek = firstOfMonth.day()
     
      const lastDayOfWeek = lastDayInMonth.day()
  
      var daysInPrevMonth = prevMonth.daysInMonth()
  
      var dayArr = []
      var prevArr = []
      var postArr = []
      for (var j = 0; j < firstDayOfWeek; j++) {
        prevArr.unshift(daysInPrevMonth)
        daysInPrevMonth--
      }
      for (var i = 1; i <= date.daysInMonth(); i++) {
        dayArr.push(i)
      }
      var dayDiff = 7 - lastDayOfWeek - 1
      if (lastDayOfWeek == 6) {
        dayDiff = 7
      }
      if (lastDayOfWeek == 5) {
        dayDiff = 9
      }
      for (var k = 1; k < dayDiff; k++) {
        postArr.push(k)
      }
      return { pre: prevArr, days: dayArr, post: postArr }
    }

    function inRange(date) {
        if(range.length == 2) {
            return (date.isAfter(range[0])||date.isSame(range[0])) && (date.isBefore(range[1])||date.isSame(range[1]))
        } else {
            return true
        }
    }
    const { pre, days, post } = generateDays(date)
    return (
      <div className="flex flex-col lg:justify-center items-center">
        <div className="flex justify-center gap-x-4 items-center">
          <CBButton
            type="qt"
            onClick={(e) => {
              var dateA = date.clone().month(date.month() - 1)
              setDate(dateA)
              onPanelChange(dateA)
            }}
          >
            {'<'}
          </CBButton>
          <span className="font-sarabun text-lg"> {date.format('LL')}</span>
          <CBButton
            onClick={(e) => {
              
              var dateA = date.clone().month(date.month() + 1)
              setDate(dateA)
              onPanelChange(dateA)
            }}
            type="qt"
          >
            {'>'}
          </CBButton>
        </div>
        <div className="grid grid-cols-7 gap-2">
        {(sundayStart ? ['S', 'M', 'T', 'W', 'T', 'F', 'S'] :['M', 'T', 'W', 'T', 'F', 'S', 'S']).map((e,i) => {
            return <div key={e +i} className={`flex justify-center m-1 text-neutral_4 p-1 items-center w-8 h-8`}>{e}</div>
          })}
          {pre.map((e,i) => {
            return (
              <div
              key={e+i}
                onClick={(q) => {
                  setDayOfMonth(e)
                  var dateA = date
                  .clone()
                  .month(date.month() - 1)
                  .date(e)
                  setDate(
                   dateA
                  )

                  onPanelChange(dateA)
                }}
                className={`text-neutral_2 text-center p-1 m-1 w-8 h-8 ${(!sundayStart && i==0) ? 'hidden':''} ${(!sundayStart && i % 7 == 0) ? `col-start-7`: `col-start-${i/7 + 1}`}`}
              >
                {e}
              </div>
            )
          })}
                    
          {days.map((e,i) => {
            const cellDate = date.clone().date(e)
            const excluded = excludedDays.includes(cellDate.format('YYYY-MM-DD'))
  
            const valid = inRange(cellDate)
            return (
              <div
              key={e+i}
                onClick={(q) => {
                    if(excluded || !valid) {
                        return
                    }
                  setDayOfMonth(e)
                  setDate(cellDate)
                  onSelect(cellDate)
                  if(!singleSelect) {
                  if (secondSelect != null) {
                    setFirstSelect(cellDate)
                    //onFirstSelect(cellDate)
                    setSecondSelect(null)
                    onRangeSelect([cellDate,null])
                  } else if (
                    firstSelect != null &&
                    (cellDate.isSame(firstSelect) ||
                      cellDate.isAfter(firstSelect))
                  ) {
                    setSecondSelect(cellDate)
                    onRangeSelect([firstSelect,cellDate])
                  } else if (firstSelect == null) {
                    setFirstSelect(cellDate)
                    onRangeSelect([cellDate,null])
                  }
                }
                }}
                className={`flex-initial h-8 w-8 focus-within
                
                
  
                ${!singleSelect && (
                  cellDate.isSame(firstSelect) || cellDate.isSame(secondSelect))
                    ? 'bg-neutral_4 text-white rounded-full' 
                    : ''
                } ${!singleSelect && (
                  cellDate.isAfter(firstSelect) && cellDate.isBefore(secondSelect))
                    ? 'bg-neutral_2'
                    : ''
                } text-center p-1 m-1 
                ${(valid && !excluded && !cellDate.isSame(date) && !loading) && 'cursor-pointer text-neutral_4 rounded-full bg-neutral_1 hover:bg-neutral_2'}
                ${(!valid || excluded) && 'rounded-full text-neutral_3'}
                ${(singleSelect && 
                  cellDate.isSame(date) && !excluded && valid && !loading) 
                   ? ' cursor-pointer bg-brand_dark_blue text-white hover:bg-brand_dark_blue rounded-full '
                   : dayOfMonth == e ? 'bg-neutral_2 text-white' : ''
               }`}
              >
                {e}
              </div>
            )
          })}{' '}
          {post.map((e,i) => {
            return (
              <div
              key={e+i}
                onClick={(q) => {
                  setDayOfMonth(e)
                  var dateA = date
                  .clone()
                  .month(date.month() + 1)
                  .date(e)
                  setDate(
                   dateA
                  )

                  onPanelChange(dateA)
                }}
                className={`text-neutral_2 text-center p-1 m-1 w-8 h-8`}
              >
                {e}
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  export { CBCalendar }